import React from 'react'
// import { I18n } from 'react-i18next'

const VCCustomContact = ({title, icon, name, phone, email, t}) => (
  // <I18n>
    // {
      // t => (
        <div className='investorContact'>
          <h2>{title}</h2>
          { icon ?
            <img src={icon} alt="icon" />
          :
            <span className='icon'></span>
          }
          <span className='name'>{name}</span>
          <span className='phone'>{phone}</span>
          <span className='email'>{email}</span>
        </div>
      // )
    // }
  // </I18n>
)

export default VCCustomContact


// WEBPACK FOOTER //
// ./src/custom/components/VCCustomContact.js